/**
 * TERRAIN — Hero JS
 * Smooth-scroll for CTA + scroll indicator.
 * Scroll-reveal IntersectionObserver for .trn-reveal elements.
 */
(function () {
  'use strict';

  /* -------- Smooth scroll for anchor links -------- */
  document.querySelectorAll('[data-trn-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* -------- Scroll-reveal observer -------- */
  /* Elements with .trn-reveal start at opacity:0 in CSS (when
     prefers-reduced-motion: no-preference). This observer adds
     .trn-reveal--visible when each element enters the viewport. */
  if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('trn-reveal--visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.trn-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  }
  /* -------- Sticky CTA bar -------- */
  /* Shows after scrolling past hero, hides when footer CTA enters viewport.
     We move the bar to <body> to escape the hero section's stacking context
     (Shopify wraps each section in a positioned element with z-index). */
  var stickyBar = document.getElementById('trn-sticky-cta');
  var hero = document.getElementById('trn-hero');
  var footerCTA = document.getElementById('trn-footer');
  var quiz = document.getElementById('trn-quiz');

  if (stickyBar) {
    document.body.appendChild(stickyBar);
  }

  if (stickyBar && hero) {
    var barVisible = false;

    /* Track hero exit — show bar when hero leaves viewport */
    var heroObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && !barVisible) {
          stickyBar.hidden = false;
          requestAnimationFrame(function () {
            stickyBar.classList.add('trn-sticky-cta--visible');
          });
          barVisible = true;
        } else if (entry.isIntersecting && barVisible) {
          stickyBar.classList.remove('trn-sticky-cta--visible');
          barVisible = false;
          setTimeout(function () { if (!barVisible) stickyBar.hidden = true; }, 350);
        }
      });
    }, { threshold: 0.1 });

    heroObserver.observe(hero);

    /* Track footer CTA — hide bar when footer enters viewport */
    if (footerCTA) {
      var footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && barVisible) {
            stickyBar.classList.remove('trn-sticky-cta--visible');
          } else if (!entry.isIntersecting && barVisible) {
            stickyBar.classList.add('trn-sticky-cta--visible');
          }
        });
      }, { threshold: 0.05 });

      footerObserver.observe(footerCTA);
    }

    /* Also hide when quiz section is in view (user is already engaging) */
    if (quiz) {
      var quizObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && barVisible) {
            stickyBar.classList.remove('trn-sticky-cta--visible');
          } else if (!entry.isIntersecting && barVisible) {
            stickyBar.classList.add('trn-sticky-cta--visible');
          }
        });
      }, { threshold: 0.3 });

      quizObserver.observe(quiz);
    }
  }
})();
